import * as React from 'react';

export function SvgTrashForever(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 7.2a1 1 0 011-1h14.4a1 1 0 110 2H5a1 1 0 01-1-1z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6 5a.6.6 0 00-.6.6v.6h4.4v-.6a.6.6 0 00-.6-.6h-3.2zm5.8 1.2v-.6A2.6 2.6 0 0013.8 3h-3.2A2.6 2.6 0 008 5.6v.6H6.6a1 1 0 00-1 1v11.2A2.6 2.6 0 008.2 21h8a2.6 2.6 0 002.6-2.6V7.2a1 1 0 00-1-1h-1.4zm-8.8 2v10.2a.6.6 0 00.6.6h8a.6.6 0 00.6-.6V8.2H7.6z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.604 11.196a1 1 0 010 1.414l-3.394 3.394a1 1 0 01-1.414-1.414l3.394-3.394a1 1 0 011.414 0z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.796 11.196a1 1 0 011.414 0l3.394 3.394a1 1 0 11-1.414 1.414L9.796 12.61a1 1 0 010-1.414z"
        fill="currentColor"
      />
    </svg>
  );
}
